import axios from "axios"

export async function getConfig() {
  const response = await axios.get('/api/v1/config')
  return response.data
}
